module.exports = __webpack_public_path__ + "img/shotRoutine1.dfe7e234.png";